export default {
  add(url: string, callback: Function) {
    if (!url) {
      return Promise.resolve();
    }
    return new Promise((resolve, reject) => {
      const downloadingImage = new Image();
      downloadingImage.onload = () => resolve(downloadingImage);
      downloadingImage.onerror = (err) => reject(err);
      downloadingImage.src = url;
    })
      .then((image) => callback(image, null))
      .catch((err) => callback(null, err));
  },
};
